import { render, staticRenderFns } from "./RolePermissionsOverview.vue?vue&type=template&id=065ecf00&scoped=true&"
import script from "./RolePermissionsOverview.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsOverview.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsOverview.vue?vue&type=style&index=0&id=065ecf00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ecf00",
  null
  
)

export default component.exports